const c=(e,n)=>e.blocks.findIndex(o=>o.key===n);export{c as getBlockIndex};
//# sourceMappingURL=draftUtils.js.map
